const DEFAULT = 'NOT_STARTED';
const LOADING = 'LOADING';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

const ACCOUNT = {
    SETUP: "SETUP",
    NOT_SET: "NOT_SET",
}

export const STATUS = Object.freeze({ DEFAULT, LOADING, SUCCESS, ERROR, ACCOUNT });

